<time [dateTime]="date"
      cllTooltip="{{ date | appDateWithYear }}"
      class="hover-dotted dotted">
    <ng-container *ngIf="short">
        {{ date | appDateShort }}
    </ng-container>

    <ng-container *ngIf="!short">
        {{ date | appDate }}
    </ng-container>
</time>
